<template>
  <billing-report-panel
    report-key="invoices-batch"
    route="/reports/billing-invoices-batch"
    file-name="notas-fiscais-por-lote.xlsx"
    period-label="Período de fechamento do lote"
    :columns="columns"
    :default-days="180"
  />
</template>

<script>
import BillingReportPanel from './BillingReportPanel.vue';

export default {
  components: {
    BillingReportPanel,
  },
  data() {
    return {
      columns: [
        'Situação da nota',
        'Lote',
        'Convênio',
        'Valor do lote',
        'Situação do lote',
        'Número da nota',
        'Emissão da nota',
        'Prazo para emissão',
        'Total por grupo',
      ],
    };
  },
};
</script>
